/* import __COLOCATED_TEMPLATE__ from './sh-invoices-record-list.hbs'; */
import { readOnly } from '@ember/object/computed';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { showModal } from "sh-www/utils/modal-controls";
import { EMBER_ROUTE_NAMES } from "../../../../constants/routes";
import { PAYIN__COLUMN_HEADERS } from "../../../../constants/routes/admin/accounting/payin";

/**
 * This is the admin view for the sh-invoices
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-sh-invoices-record-list'],

  /**
   * Register services
   */
  applicationStateManager: service('state-managers/application'),
  state: service('states/routes/admin/accounting/payin'),
  stateManager: service('state-managers/routes/admin/accounting/payin'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * Array of the payin column headers for the template.
   *
   * @type {String[]}
   */
  _constantsColumnHeaders: PAYIN__COLUMN_HEADERS,

  /**
   * @type {Boolean}      True when we have more pages in our list pagination
   */
  _hasMorePages: computed(
  'state.currentPagination.currentPage',
  'state.currentPagination.totalPages',
  function() {
    return this.get('state.currentPagination.currentPage') < this.get('state.currentPagination.totalPages');
  }),

  /**
   * @type {Boolean}
   */
  _isShowPaginator: computed('state.currentPagination.total', function() {
    return this.get('state.currentPagination.total');
  }),

  /**
   * @type {Pagination}
   */
  _pagination: readOnly('state.currentPagination'),

  actions: {

    /**
     *
     */
    onAdvancePageForward() {
      return this.get('stateManager').loadNextInvoicesPage();
    },

    /**
     * @param {Boolean} isSend      When true, we want to send the invoice after batching as well.
     */
    onConfirmBatchClicked(isSend) {
      let invoicesToBatch = this.get('state.batchedInvoicesSelected'),
        bodyText = isSend ?
          `${invoicesToBatch.get('length')} will be batched and sent.` :
          `${invoicesToBatch.get('length')} will be batched.`;

      let data = {
        titleText: "Batch Confirmation",
        bodyText: bodyText,
        actionButtonText: 'OK',
        cancelButtonText: 'Cancel',
        isShowCancelButton: true,
        confirmAction: () => {
          this.get('stateManager').batchSelectedInvoices(isSend).then(newShInvoice => {
            this.get('applicationStateManager').setNextRoute(
              EMBER_ROUTE_NAMES.ADMIN__ACCOUNTING__PAYIN__SH_INVOICE,
              null,
              newShInvoice.get('id'));
          });
        }
      };

      showModal(this, 'confirmation', data);
    },

    onSelectAllInvoicesClicked() {
      this.stateManager.toggleBatchedSelectAll();
    },

    /**
     *
     */
    onSortCompanyClicked() {
      this.get('stateManager').toggleSortCompanyDescending();
    }
  }
});
